import Vue from 'vue'
import Router from 'vue-router'

import Catalog from './views/Catalog.vue'
import List from './views/List.vue'
import ItemDetailView from './views/ItemDetailView.vue'
import Login from './views/Login.vue'
import Meals from './views/Meals.vue'
import MealDetailView from './views/MealDetailView.vue'
import MealIngredientPicker from './views/MealIngredientPicker.vue'
import Setup from './views/Setup.vue'
import Missing from './views/Missing.vue'

Vue.use(Router)

const ShellView = { render (h) { return h('router-view') } }

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: List,
      meta: {
        showSearch: true,
        pageTitle: 'Needed'
      }
    },
    {
      path: '/items',
      component: ShellView,
      children: [
        {
          path: '',
          name: 'catalog',
          component: Catalog,
          meta: {
            pageTitle: 'All Items'
          }
        },
        {
          path: 'new',
          name: 'item-create',
          component: ItemDetailView,
          props: true
        },
        {
          path: ':id',
          name: 'item-edit',
          component: ItemDetailView,
          props: true
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        showSearch: false,
        pageTitle: 'Sign In'
      }
    },
    {
      path: '/meals',
      component: ShellView,
      children: [
        {
          path: '',
          name: 'meals',
          component: Meals,
          meta: {
            pageTitle: 'Meals'
          }
        },
        {
          path: 'new',
          name: 'meal-create',
          component: MealDetailView
        },
        {
          path: ':id',
          name: 'meal-edit',
          component: MealDetailView,
          props: true
        },
        {
          path: ':id/picker',
          name: 'meal-ingredient-picker',
          component: MealIngredientPicker,
          props: true
        }
      ]
    },
    {
      path: '/setup',
      name: 'setup',
      component: Setup,
      meta: {
        pageTitle: 'Setup'
      }
    },
    { path: '/missing', component: Missing, meta: { pageTitle: 'Page not found...' } },
    { path: '*', redirect: '/missing' }
  ]
})
